export default __webpack_public_path__ + "static/media/red-cross.de4f876a.svg";